// Registers public/service-worker.js, which makes the app shell itself (not just scan data —
// that's src/lib/offlineStore.js's job) available with zero network. Production builds only:
// registering it in `yarn start` would just fight hot reload for no benefit, since dev is never
// what's running on an operator's phone.

export function register() {
    if (process.env.NODE_ENV !== "production") return;
    if (!("serviceWorker" in navigator)) return;
    // Service workers require a secure context — same guard the camera scanner already uses
    // elsewhere in this app (see Scan.jsx's startScanner).
    if (!window.isSecureContext) return;

    window.addEventListener("load", () => {
        navigator.serviceWorker
            // updateViaCache: "none" — always fetch this script fresh on registration instead
            // of trusting whatever HTTP cache headers the static host sent for it. Without this,
            // a deploy that changes service-worker.js itself could sit uninstalled behind an
            // HTTP-cached copy of the old one for a long time.
            .register("/service-worker.js", { updateViaCache: "none" })
            .catch(() => {
                // Best-effort — the app still works online without it, it just won't have an
                // offline app shell until the next successful registration.
            });
    });
}
